import { useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint } from '@/api/api.generated';
import type { ITopFiveApiV2EndpointsTopFiveGetPeriodsPeriodOption } from '@/api/models';

/**
 * Period option returned from the API.
 * Re-exported from generated models for convenience.
 */
export type PeriodOption = ITopFiveApiV2EndpointsTopFiveGetPeriodsPeriodOption;

/**
 * Custom hook to fetch available TopFive periods for import.
 * Returns 6 periods (3 cadence types × current/previous).
 * 
 * @example
 * ```tsx
 * const { data: periods, isLoading, error } = usePeriods();
 * 
 * if (isLoading) return <div>Loading periods...</div>;
 * if (error) return <div>Error loading periods</div>;
 * 
 * return (
 *   <select>
 *     {periods?.map(p => (
 *       <option key={`${p.cadenceType}-${p.period}`} value={JSON.stringify(p)}>
 *         {p.displayName} - {p.description}
 *       </option>
 *     ))}
 *   </select>
 * );
 * ```
 */
export const usePeriods = () => {
  return useITopFiveApiV2EndpointsTopFiveGetPeriodsGetPeriodsEndpoint({
    query: {
      select: (data) => data.data.periods ?? [],
      staleTime: 5 * 60 * 1000, // 5 minutes - periods don't change frequently
      gcTime: 10 * 60 * 1000, // 10 minutes cache time (formerly cacheTime)
    },
  });
};
